import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservablePerformanceConfigRequest, RpcObservablePerformanceError, RpcObservablePerformanceKey, RpcObservablePerformanceResult
} from './rpc-observable-performance-model';

export class RpcObservablePerformanceConfigClient
    extends RpcObservableClient<RpcObservablePerformanceConfigRequest, RpcObservablePerformanceResult, RpcObservablePerformanceError>  {

    /**
     * Initializes a new instance of the RpcObservablePerformanceConfigClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservablePerformanceKey.configCommand, RpcObservablePerformanceKey.version);
    }

    /**
     * The Performance config command.
     *
     * @param request the Rpc Performance config object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservablePerformanceResult> the observable object.
     */
    public config(request: RpcObservablePerformanceConfigRequest, outbound?: RpcOutbound): Observable<RpcObservablePerformanceResult> {
        return this.observableCall(request, outbound);
    }
}
